import { GlobalModal } from "./GlobalModal";
import { GlobalButton } from "./forms/GlobalFormFields";
import "./GlobalErrorFlashModal.css";

/**
 * Error dialog matching the compact success flash pattern.
 */
export default function GlobalErrorFlashModal({
  message,
  onDismiss,
  title = "Error",
  okLabel = "OK",
}) {
  const open = Boolean(message && String(message).trim());

  return (
    <GlobalModal
      open={open}
      onClose={onDismiss}
      title={title}
      size="sm"
      closeOnBackdrop={false}
      closeOnEscape={false}
      showCloseButton={false}
      classNames={{
        modal: "gff-modal gef-error-flash",
        header: "gff-modal__header gef-error-flash__header",
        title: "gff-modal__title gef-error-flash__title",
        body: "gff-modal__body gef-error-flash__body",
        footer: "gff-modal__footer gef-error-flash__footer",
      }}
      footer={
        <GlobalButton variant="primary" type="button" onClick={onDismiss}>
          {okLabel}
        </GlobalButton>
      }
    >
      <p className="gef-error-flash__msg">{message}</p>
    </GlobalModal>
  );
}
